// extracted by mini-css-extract-plugin
module.exports = {"topics":"topic-tags_topics__sExcf","heading":"topic-tags_heading__m5ArW"};